export const formatCurrency = (
  amount: number | bigint,
  locale: string | string[],
  currency: string,
  decimals = 2
): string => {
  // Use provided decimals or default to 2
  const fractionDigits = decimals;

  return Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(amount);
};
